<template>
  <div class="mainBox">
    <div class="mainContent">
      <div class="mainContent_title">
        <span
          class="mainContent_firstTitle"
          @click="goHome"
        >主頁 /</span>
        <span class="mainContent_lastTitle">Coupon著數</span>
      </div>
      <div class="couponCategoryBox">
        <div class="couponCategoryBox_title">
          <span>{{ $t("mainContent.selectCoupon") }}:</span>
        </div>
        <div
          class="couponCategoryBox_btnList"
          v-if="hotKeys.length > 0"
        >
          <span
            v-for="(hotKey, index) in hotKeys"
            :key="index"
            @click="cutoverSelectedCoupon(hotKeys[index], $event)"
          >{{ hotKeys[index] }}</span>
        </div>
      </div>
      <div class="newWeekCouponBox">
        <div class="newWeekCoupon_title">本週新Coupon</div>
        <div class="titleUnderline"></div>
        <VueSlickCarousel
          :arrows="true"
          :dots="true"
          :rows="carouselRows"
          v-if="couponsList.length!==0"
          class="vue-slick-carousel"
        >
          <div
            class="selected_couponBigEventContent"
            v-for="list in couponsList"
            :key="list.id"
            @click="goCouponDetail(list.couponId)"
            ref="newWeekCouponEventContent"
          >
            <div class="small_couponEventContent">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="small_couponEventContent_img col-4 col-sm-5"
                    ref="newWeekImgBox"
                  >
                    <div class="img-wrapper">
                      <img
                        :src="list.detailBannerUrl"
                        alt
                      />
                    </div>
                  </div>
                  <div class="small_content_right col-8 col-sm-7">
                    <div class="small_content_right_img">
                      <span @click="pushMerchantPage($event,list)">{{ list.merchantName }}</span>
                    </div>
                    <ul>
                      <li
                        v-if="list.couponType === 'Percentage Off'"
                        class="small_per_symbol"
                      >
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(list.amount).toFixed(2))
                        }}</span>
                        {{ list.symbol }}
                      </li>
                      <li
                        v-if="list.couponType === 'Fixed Amount'"
                        class="small_per_symbol"
                      >
                        {{ list.symbol }}
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(list.amount).toFixed(2))
                        }}</span>
                      </li>
                      <li
                        v-if="list.couponType === 'Amount Off'"
                        class="small_per_symbol"
                      >
                        {{ list.symbol }}
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(list.amount).toFixed(2))
                        }}</span>
                        off
                      </li>
                      <li class="small_per_text">Purchasing offer</li>
                      <li class="small_validityDate">
                        Validity Period: {{ list.effectiveStartDate }} -
                        {{ list.effectiveEndDate }}
                      </li>
                    </ul>
                    <div class="verbar">
                      <template v-if="Number(list.price) === 0">
                        <div class="small_redeem_button">
                          <i class="icon">
                            <img src="@/assets/images/icon-heart.svg" />
                          </i>
                          Download
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="small_redeem_button price_button"
                          @click.stop="addCart(list)"
                        >
                          <i class="icon iconfont icon-shopping"></i>
                          ${{ parseFloat(list.price).toFixed(2) }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
      <div class="selectedCouponBox">
        <div class="selectedCouponBox_title">Rabbitzhop 精選</div>
        <div class="titleUnderline"></div>
        <div class="SelectedCouponContent row">
          <div
            class="selected_couponBigEventContent col-12 col-sm-6 col-md-6 col-lg-4"
            v-for="item in selectedCouponsList"
            :key="item.id"
            @click="goCouponDetail(item.couponId)"
            ref="selectedcouponBoxWidth"
          >
            <div class="small_couponEventContent">
              <div class="panel-body">
                <div class="row">
                  <div
                    class="small_couponEventContent_img col-4 col-sm-5"
                    ref="imgBox"
                  >
                    <div class="img-wrapper">
                      <img
                        :src="item.detailBannerUrl"
                        alt
                      />
                    </div>
                  </div>
                  <div class="small_content_right col-8 col-sm-7">
                    <div class="small_content_right_img">
                      <span @click="pushMerchantPage($event,item)">{{ item.merchantName }}</span>
                    </div>
                    <ul>
                      <li
                        v-if="item.couponType === 'Percentage Off'"
                        class="small_per_symbol"
                      >
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(item.amount).toFixed(2))
                        }}</span>
                        {{ item.symbol }}
                      </li>
                      <li
                        v-if="item.couponType === 'Fixed Amount'"
                        class="small_per_symbol"
                      >
                        {{ item.symbol }}
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(item.amount).toFixed(2))
                        }}</span>
                      </li>
                      <li
                        v-if="item.couponType === 'Amount Off'"
                        class="small_per_symbol"
                      >
                        {{ item.symbol }}
                        <span class="newWeek_percentage">{{
                          parseFloat(parseFloat(item.amount).toFixed(2))
                        }}</span>
                        off
                      </li>
                      <li class="small_per_text">Purchasing offer</li>
                      <li class="small_validityDate">
                        Validity Period: {{ item.effectiveStartDate }} -
                        {{ item.effectiveEndDate }}
                      </li>
                    </ul>
                    <div class="verbar">
                      <template v-if="Number(item.price) === 0">
                        <div class="small_redeem_button">
                          <i class="icon">
                            <img src="@/assets/images/icon-heart.svg" />
                          </i>
                          Download
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="small_redeem_button price_button"
                          @click.stop="addCart(item)"
                        >
                          <i class="icon iconfont icon-shopping"></i>
                          ${{ parseFloat(item.price).toFixed(2) }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <div
            class="more"
            @click="loadMoreSelectedCouponsContent"
            v-show="moreBtnStyle"
          >
            {{ $t("mainContent.more") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCoupons, getWeekCoupons, getSystemConfig } from '@/api/coupon'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

const systemConfigKey = 'COUPON_HOT_CATEGORY'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      carouselRows: 3,
      fullWidth: document.documentElement.clientWidth,
      couponsList: [],
      selectedCouponsList: [],
      selectedCouponsListBackups: [],
      selectedKeyCouponsList: [],
      smallCouponEventBoxStyle: {
        transform: 'translateX(-1123px)'
      },
      selectedKeyCouponsBtnClick: '',
      selectedKeyCouponsBtnClickNum: '',
      eventBoxTranslateX: 0,
      clickNewWeekNum: 0,
      clickMoreNum: 1,
      newWeedEventImgHeight: '',
      newWeekEventContentHeight: '',
      eventImgHeight: '',
      selectedcouponBoxWidth: '',
      moreBtnStyle: false,
      systemConfigKey,
      hotKeys: []
    }
  },
  watch: {
    selectedCouponsList: function () {
      if (this.selectedCouponsList) {
        this.$nextTick(() => {
          this.initImgHeight()
        })
      }
    }
  },
  mounted () {
    this.getCarouselRows()
    getWeekCoupons({
      pageSize: 20
    }).then((res) => {
      this.couponsList = res.list
    })
    getCoupons({
      pageNo: 1,
      pageSize: 0
    }).then((res) => {
      this.selectedCouponsList = this.shuffleArray(res.list)
      this.selectedCouponsListBackups = JSON.parse(JSON.stringify(res.list))

      if (this.selectedCouponsList.length < 6) {
        this.moreBtnStyle = false
      }
    })
    getSystemConfig(systemConfigKey).then((res) => {
      this.hotKeys = res.data.value.split(/[\n,]/)
    })

    const that = this
    window.onresize = () => {
      return (() => {
        // const imgBox = this.$refs.imgBox
        // const wImgbox = imgBox[0].getBoundingClientRect().width
        // that.eventImgHeight = wImgbox + 'px'

        window.fullWidth = document.documentElement.clientWidth
        that.fullWidth = window.fullWidth
        if (that.fullWidth >= 1200) {
          this.carouselRows = 3
        } else if (that.fullWidth >= 992) {
          this.carouselRows = 2
        } else {
          this.carouselRows = 1
        }

        // if (that.fullWidth <= 1500 && that.fullWidth >= 1000) {
        //   that.newWeekEventContentHeight =
        //     (that.$refs.smallCouponEventBox.clientWidth - 80) / 2
        // } else if (that.fullWidth <= 1000) {
        //   that.newWeekEventContentHeight =
        //     that.$refs.smallCouponEventBox.clientWidth - 20
        //   console.log(1222)
        // } else {
        //   that.newWeekEventContentHeight =
        //     (that.$refs.smallCouponEventBox.clientWidth - 120) / 3
        // }

        if (that.fullWidth <= 1350 && that.fullWidth > 1000) {
          that.selectedcouponBoxWidth = 50
        } else if (that.fullWidth <= 1000) {
          that.selectedcouponBoxWidth = 100
        } else {
          that.selectedcouponBoxWidth = 33.3
        }

        // this.$nextTick(() => {
        //   this.newWeedEventImgHeight =
        //     this.$refs.newWeekImgBox[0].getBoundingClientRect().width + 'px'
        // })
      })()
    }
  },
  methods: {
    ...mapMutations('cart', [
      'addCart'
    ]),
    getCarouselRows () {
      window.fullWidth = document.documentElement.clientWidth
      if (window.fullWidth >= 1200) {
        this.carouselRows = 3
      } else if (window.fullWidth >= 992) {
        this.carouselRows = 2
      } else {
        this.carouselRows = 1
      }
    },
    initImgHeight: function (params) {
      this.$nextTick(() => {
        if (this.fullWidth <= 1350 && this.fullWidth > 1000) {
          this.selectedcouponBoxWidth = 50
        } else if (this.fullWidth <= 1000) {
          this.selectedcouponBoxWidth = 100
        } else {
          this.selectedcouponBoxWidth = 33.3
        }
      })
    },

    loadMoreSelectedCouponsContent: function () {
      this.clickMoreNum++
      console.log(this.clickMoreNum)
      getCoupons({
        pageNo: this.clickMoreNum,
        pageSize: 6
      }).then((res) => {
        const newCouponList = res.list
        console.log(newCouponList.length)
        if (newCouponList.length < 6) {
          this.moreBtnStyle = false
        }
        this.$nextTick(() => {
          this.selectedCouponsList.push.apply(
            this.selectedCouponsList,
            newCouponList
          )
          console.log(this.selectedCouponsList)
        })
      })
    },
    /*
      nextCouponCard: function (params) {
        console.log(this.$refs.smallCouponEventBox.clientWidth)
        if (this.fullWidth <= 1500 && this.fullWidth >= 1000) {
          if (this.clickNewWeekNum >= parseInt(this.couponsList.length / 2)) {
          } else {
            this.eventBoxTranslateX += -(
              this.$refs.newWeekCouponEventContent[0].getBoundingClientRect()
                .width *
                2 +
              80
            )
            this.clickNewWeekNum++
          }
        } else if (this.fullWidth <= 1000) {
          if (this.clickNewWeekNum >= this.couponsList.length) {
          } else {
            this.eventBoxTranslateX += -(
              this.$refs.newWeekCouponEventContent[0].getBoundingClientRect()
                .width + 20
            )
            this.clickNewWeekNum++
          }
        } else {
          if (this.clickNewWeekNum >= parseInt(this.couponsList.length / 3)) {
          } else {
            this.eventBoxTranslateX += -(
              this.$refs.newWeekCouponEventContent[0].getBoundingClientRect()
                .width *
                3 +
              120
            )
            this.clickNewWeekNum++
          }
        }
      },
  
      prevCouponCard: function (params) {
        if (this.clickNewWeekNum === 0) {
        } else {
          if (this.fullWidth <= 1500 && this.fullWidth >= 1000) {
            this.eventBoxTranslateX +=
              this.$refs.newWeekCouponEventContent[0].getBoundingClientRect()
                .width *
                2 +
              80
          } else if (this.fullWidth <= 1000) {
            this.eventBoxTranslateX +=
              this.$refs.newWeekCouponEventContent[0].getBoundingClientRect()
                .width + 20
          } else {
            this.eventBoxTranslateX +=
              this.$refs.newWeekCouponEventContent[0].getBoundingClientRect()
                .width *
                3 +
              120
          }
          this.clickNewWeekNum--
        }
      },
      */

    cutoverSelectedCoupon: function (params, event) {
      const couponKeyword = params

      event.path[1].children.forEach((element) => {
        element.style.background = '#ffffff'
        element.style.color = '#0F96BB'
      })
      if (
        this.selectedKeyCouponsBtnClick === event.target &&
        this.selectedKeyCouponsBtnClickNum !== true
      ) {
        event.target.style.background = '#ffffff'
        event.target.style.color = '#0F96BB'
        this.selectedCouponsList = JSON.parse(
          JSON.stringify(this.selectedCouponsListBackups)
        )
        this.moreBtnStyle = true
        this.selectedKeyCouponsBtnClickNum = true
      } else if (
        this.selectedKeyCouponsBtnClick === event.target &&
        this.selectedKeyCouponsBtnClickNum === true
      ) {
        event.target.style.background = '#0F96BB'
        event.target.style.color = '#ffffff'
        this.selectedCouponsList = JSON.parse(
          JSON.stringify(this.selectedKeyCouponsList)
        )
        this.selectedKeyCouponsBtnClickNum = false
      } else {
        event.target.style.background = '#0F96BB'
        event.target.style.color = '#ffffff'
        getCoupons({
          keyword: couponKeyword,
          pageSize: 100
        }).then((res) => {
          this.selectedCouponsList = JSON.parse(JSON.stringify(res.list))
          this.selectedKeyCouponsList = JSON.parse(JSON.stringify(res.list))
          this.moreBtnStyle = false
          this.selectedKeyCouponsBtnClick = event.target
        })
      }
    },

    goCouponDetail: function (params) {
      const couid = params
      this.$router.push({
        path: `/coupon/${couid}`
      })
    },

    goHome: function (params) {
      this.$router.push({
        path: '/'
      })
    },

    shuffleArray (array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1))
        var temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    },

    /* 跳转 merchant 页面 */
    pushMerchantPage (e, { merchantId }) {
      if (merchantId) {
        this.$router.push({ name: 'merchant', params: { merchantId } })
        e.stopPropagation()
      }
    }
  },
  components: {
    VueSlickCarousel
  }
}

</script>

<style scoped>
.mainBox {
  background: #fafafa;
}

.mainContent {
  text-align: left;
  max-width: 1280px;
  padding: 0 15px;
  margin: 0 auto;
}

.mainContent_title {
  position: relative;
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.05em;
  padding-top: 70px;
}

.mainContent_firstTitle {
  color: #666666;
}

.mainContent_lastTitle {
  color: #0f96bb;
}

.couponCategoryBox {
  margin-top: 36px;
  position: relative;
  text-align: left;
}

.couponCategoryBox_title {
  font-weight: 500;
  font-size: 22px;
  letter-spacing: 0.1em;
  color: #0f96bb;
  margin-bottom: 12px;
}

.couponCategoryBox_btnList span {
  display: inline-block;
  padding: 0 15px;
  height: 40px;
  background: #ffffff;
  color: #0f96bb;
  font-size: 16px;
  border: 1px solid #0f96bb;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
  margin-right: 15px;
  cursor: pointer;
}

.couponCategoryBox_btnList span:hover {
  background: #0f96bb !important;
  color: #ffffff !important;
}

.newWeekCouponBox {
  margin-top: 50px;
  position: relative;
  text-align: left;
}

.newWeekCouponContent {
  display: flex;
  margin: 0 -40px;
  align-items: center;
  justify-content: space-between;
}

.newWeekCouponContent:after {
  content: "";
  display: block;
  clear: both;
}

.newWeekCoupon_title {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  letter-spacing: 0.1em;
  color: #0f96bb;
}

.titleUnderline {
  width: 50px;
  background: #ffbf00;
  border-radius: 3px;
  height: 5px;
  margin-top: 10px;
}

.titleUnderline::after {
  content: "";
  display: block;
  width: 5px;
  background: #ffbf00;
  border-radius: 3px;
  height: 5px;
  margin-top: 10px;
  margin-left: 60px;
}

.newWeekCoupon_prevBtn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
}

.newWeekCoupon_prevBtn img {
  width: 12px;
  margin-right: 5px;
}

.newWeekCoupon_nextBtn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
}

.newWeekCoupon_nextBtn img {
  width: 12px;
  margin-left: 5px;
}

.newWeekCoupon_eventBox {
  width: 100%;
  overflow: hidden;
  margin-top: 30px;
}

.newWeek_couponEventListBox {
  float: left;
  margin: 0 auto;
  display: flex;
  transition-duration: 1s;
}

.newWeek_couponEventContent {
  position: relative;
  overflow: hidden;
  width: 485px;
  height: 230px;
  background: #ffffff;
  margin: 30px 20px;
  padding: 0;
  float: left;
  box-shadow: 9px 8px 10px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.newWeek_couponEventContent:hover {
  transform: scale(1.1);
  transition-duration: 0.3s;
  z-index: 3;
}

.newWeek_couponEventContent::before {
  content: "";
  display: block;
  position: absolute;
  width: 7px;
  height: 30px;
  background: #fafafa;
  border-radius: 50%;
  top: 50%;
  transform: translate(-15px, -15px);
  padding: 0;
  box-shadow: inset -16px 0px 15px -18px rgba(0, 0, 0, 0.2);
}

.newWeek_couponEventContent::after {
  content: "";
  display: block;
  position: absolute;
  width: 7px;
  height: 30px;
  background: #fafafa;
  border-radius: 50%;
  right: 0;
  top: 50%;
  transform: translate(15px, -15px);
  padding: 0;
  float: left;
  box-shadow: inset 50px 0px 15px -18px rgba(0, 0, 0, 0.15);
}

.newWeek_couponEventContent_img {
  border-radius: 100%;
  overflow: hidden;
  position: relative;
  width: 41.66666667%;
  height: 146px;
  border-radius: 50%;
  margin: 0 15px 0 25px;
}

.newWeek_couponEventContent_img img {
  /* transform: translate(-262px, 23px) scale(1.15, 1.15); */
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
}

.newWeek_content_right {
  width: 54%;
  margin-right: 30px;
}

.newWeek_content_right_img {
  font-weight: 500;
  text-align: left;
  font-size: 12px;
}

.newWeek_couponEventContent ul {
  list-style-type: none;
  padding-left: 0px;
  text-align: left;
  margin-left: 10px;
  margin-bottom: 12px;
}

.newWeek_percentage {
  font-weight: 700;
  font-family: "Poppins", "Noto Sans TC", sans-serif, "Microsoft JhengHei",
    "Microsoft Yahei", "Hiragino Sans GB";
  font-size: 2.55em;
  line-height: 1;
  color: #0f96bb;
}

ul .newWeek_per_symbol {
  color: #0f96bb;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
}

ul .newWeek_per_text {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #000000;
}

ul .newWeek_validityDate {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #b3b3b3;
}

.selectedCouponBox {
  margin-top: 40px;
  position: relative;
  text-align: left;
  padding-bottom: 70px;
}

.selectedCouponBox_title {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: #0f96bb;
}

.SelectedCouponContent {
  margin-top: 30px;
}

.SelectedCouponContent:after {
  content: "";
  display: block;
  clear: both;
}

.selected_couponEventContent {
  position: relative;
  overflow: hidden;
  transition-duration: 0.3s;
  padding: 0;
  float: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selected_couponEventContent::before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  background: #fafafa;
  border-radius: 50%;
  top: 50%;
  transform: translate(-15px, -15px);
  padding: 0;
  box-shadow: inset -16px 0px 15px -18px rgba(0, 0, 0, 0.2);
}

.selected_couponEventContent::after {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  background: #fafafa;
  border-radius: 50%;
  right: 0;
  top: 50%;
  transform: translate(15px, -15px);
  padding: 0;
  float: left;
  box-shadow: inset 50px 0px 15px -18px rgba(0, 0, 0, 0.15);
}

.selected_couponEventContent ul {
  list-style-type: none;
  padding-left: 0px;
  text-align: left;
  margin: 0 0 10px 0;
}

@media (max-width: 1515px) and (min-width: 1000px) {
  .newWeek_redeem_button {
    bottom: 20px;
  }
}

@media (max-width: 1000px) and (min-width: 0px) {
  .mainContent_title {
    font-size: 0.9rem;
    padding-top: 1.5rem;
  }

  .couponCategoryBox {
    margin-top: 1rem;
  }

  .couponCategoryBox_title {
    font-size: 1.2rem;
  }

  .couponCategoryBox_btnList span {
    padding: 0 0.5rem;
    height: 2rem;
    font-size: 0.7rem;
    line-height: 2rem;
    margin-right: 0.4rem;
  }

  .newWeekCouponBox {
    margin-top: 1.8rem;
  }

  .newWeek_couponEventContent {
    margin: 15px 10px;
    padding: 0;
    height: auto;
    padding: 10px 0;
    box-shadow: 4px 6px 10px rgba(0, 0, 0, 0.15);
  }

  .newWeek_couponEventContent::after {
    box-shadow: inset 50px 0px 15px -18px rgba(0, 0, 0, 0.097);
  }

  ul .newWeek_per_symbol {
    font-size: 0.8rem;
  }

  .newWeek_percentage {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }

  .newWeekCoupon_prevBtn img {
    width: 6px;
    margin-right: 2px;
  }

  .newWeekCoupon_prevBtn {
    width: 6%;
    height: 22px;
  }

  .newWeekCoupon_nextBtn img {
    width: 6px;
    margin-right: 2px;
  }

  .newWeekCoupon_nextBtn {
    width: 6%;
    height: 22px;
  }

  .newWeekCoupon_eventBox {
    width: 88%;
    overflow: hidden;
  }

  .newWeek_couponEventContent_img {
    width: 6rem;
    height: 6rem;
    margin-left: 25px;
  }

  .newWeek_content_right {
    width: 54%;
    margin-right: 25px;
  }

  .newWeek_content_right_img span {
    font-size: 0.8rem;
  }

  ul .newWeek_per_text {
    font-size: 0.6rem;
  }

  ul .newWeek_validityDate {
    font-size: 0.5rem;
  }

  .verbar {
    padding-bottom: 1.8rem;
  }

  .newWeek_redeem_button {
    width: 5rem;
    height: 2rem;
    font-size: 0.9rem;
    line-height: 2rem;
    bottom: 0.55rem;
  }

  .selected_couponEventContent {
    height: auto;
    padding: 10px 0;
  }

  .selectedCouponBox {
    padding-bottom: 20px;
  }
}

@media (min-width: 768px) and (max-width: 1280px) {
  .newWeek_couponEventListBox .small_couponEventContent {
    width: 40%;
  }
  .newWeekCouponContent {
    margin: 0;
  }

  .selectedCouponBox {
    padding: 0 15px;
  }
}

/* vue-slick-carousel的样式 */
::v-deep .vue-slick-carousel {
  margin: 30px 0 0;
  padding: 0 15px;
}
::v-deep .slick-list .slick-slide {
  display: flex !important;
}

::v-deep .slick-list .slick-slide > div {
  /* width: 100%; */
  flex: 1;
}

::v-deep .vue-slick-carousel .slick-arrow {
  right: 0;
  z-index: 333;
  opacity: 0.5;
}
::v-deep .slick-prev {
  left: 0;
}

::v-deep .vue-slick-carousel .slick-arrow::before {
  position: absolute;
  top: 0;
  font-family: "slick";
  font-size: 40px;
  line-height: 1;
  color: #949494;
  -webkit-font-smoothing: antialiased;
  transform: translateY(-45%);
  box-shadow: 0px 3px 10px rgb (0 0 0 / 10%);
}
::v-deep .vue-slick-carousel .slick-arrow:hover {
  opacity: 1;
}

::v-deep .vue-slick-carousel .slick-prev::before {
  right: -5px;
}

::v-deep .vue-slick-carousel .slick-next::before {
  left: -5px;
}

@media screen and (max-width: 768px) {
  ::v-deep .vue-slick-carousel {
    padding: 0;
  }

  ::v-deep .vue-slick-carousel .slick-arrow {
    display: none;
  }

  ::v-deep .vue-slick-carousel .slick-arrow::before {
    display: none;
  }

  ::v-deep .vue-slick-carousel .slick-arrow::before {
    font-size: 25px;
    transform: translateY(-60%);
  }

  ::v-deep .vue-slick-carousel .slick-prev::before {
    right: 10px;
  }

  ::v-deep .vue-slick-carousel .slick-next::before {
    left: 10px;
    top: 0;
  }
}

.small_content_right_img span {
  display: inline-block;
}

.small_content_right_img span:hover {
  color: #0f96bb;
}
</style>
